// Example: Redirect within Loyalty Lion app
function getPopup() {
  var popiframe = document.getElementById("loyaltylion-popup-frame");
  console.log("Pop iframe");
  console.log(popiframe);

  const root = Shopify.routes.root;
  // Function to attach the redirection event listener
  const redirectionClick = (selector) => {
    const redirectElements =
      popiframe.contentDocument.querySelectorAll(selector); // Get all elements that match the selector

    redirectElements.forEach((redirectElement) => {
      console.log("Attaching event listener to:", redirectElement);

      redirectElement.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent default navigation behavior

        // Find the closest anchor tag and get the href attribute
        const anchor = e.target.closest("a");
        if (anchor && anchor.getAttribute("href")) {
          const targetPath = anchor.getAttribute("href"); // Safely get href
          const redirectUrl = root + targetPath; // Construct the full redirect URL

          console.log("Redirecting to:", redirectUrl);
          window.location.assign(redirectUrl); // Perform the redirection
        } else {
          console.log("No valid href found for the clicked element");
        }
      });
    });
  };

  // Check if the current language is not 'en-it'
  if (root != "/") {
    // Attach the event listener to relevant elements
    redirectionClick('a[data-testid="signup-button"]');
    redirectionClick('a[data-testid="login-button"]');
  } else {
    console.log("Language is en-it, no redirection needed.");
  }
}

function getloyalityFrame() {
  var yiframe = document.getElementById("loyaltylion-beacon-frame");
  const beaconDiv = yiframe.contentDocument.querySelector(
    'div[data-testid="beacon"]'
  );
  if (beaconDiv) {
    beaconDiv.addEventListener("click", () => {
      console.log("Frame clicked");
      setTimeout(getPopup, 1000);
    });
  } else {
    console.warn("beaconDiv not found.");
  }
}

setTimeout(getloyalityFrame, 2000);
